import React from 'react';


const PerformanceHeatMap = ({ data, viewMode }) => {
  const getHeatColor = (value) => {
    if (value >= 90) return 'bg-success/20 text-success border-success/30';
    if (value >= 75) return 'bg-teal-500/20 text-teal-600 border-teal-500/30';
    if (value >= 60) return 'bg-amber-500/20 text-amber-600 border-amber-500/30';
    if (value >= 40) return 'bg-warning/20 text-warning border-warning/30';
    return 'bg-error/20 text-error border-error/30';
  };

  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const hours = viewMode === 'hourly' ?
  ['12AM', '3AM', '6AM', '9AM', '12PM', '3PM', '6PM', '9PM'] :
  ['Week 1', 'Week 2', 'Week 3', 'Week 4'];

  return;


























































};

export default PerformanceHeatMap;